module.exports = __webpack_public_path__ + "static/media/01.0a8a2ee8.png";